export default __webpack_public_path__ + "static/media/50 inex_03.2e20b193.png";